// Player image fixes and overrides for specific players
export const PLAYER_IMAGE_OVERRIDES: Record<string, string> = {
  // Lamar Jackson (QB, Baltimore Ravens) - using his correct ESPN ID
  'lamar jackson': 'https://a.espncdn.com/i/headshots/nfl/players/full/3916387.png',
  
  // Add other problematic players here as needed
  // 'player name': 'correct_image_url'
};

// Function to get the correct player image with overrides
export const getPlayerImageWithOverrides = (
  playerName: string | undefined,
  espnId: string | undefined,
  fallbackUrl: string = 'https://a.espncdn.com/i/headshots/nophoto.png'
): string => {
  if (!playerName) {
    return fallbackUrl;
  }

  const normalizedName = playerName.toLowerCase();
  
  // Check for manual overrides first
  if (PLAYER_IMAGE_OVERRIDES[normalizedName]) {
    return PLAYER_IMAGE_OVERRIDES[normalizedName];
  }

  // Use ESPN ID if available
  if (espnId) {
    return `https://a.espncdn.com/i/headshots/nfl/players/full/${espnId}.png`;
  }

  return fallbackUrl;
};

// Debug function to log player image mapping issues
export const debugPlayerImageMapping = (playerName: string, espnId: string | undefined) => {
  const normalizedName = playerName.toLowerCase();
  
  if (PLAYER_IMAGE_OVERRIDES[normalizedName]) {
    console.log(`🔧 Using image override for ${playerName}: ${PLAYER_IMAGE_OVERRIDES[normalizedName]}`);
  } else if (!espnId) {
    console.log(`⚠️ No ESPN ID found for ${playerName}, using fallback image`);
  } else {
    console.log(`✅ Using ESPN ID ${espnId} for ${playerName}`);
  }
}; 